export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-1.d7ff8367.svg";